export const GET_CLOUD_DOCUMENTS = "FUND@GET_CLOUD_DOCUMENTS";
export const GET_CLOUD_DOCUMENTS_INIT = "FUND@GET_CLOUD_DOCUMENTS_INIT";
export const GET_CLOUD_DOCUMENTS_SUCCESS = "FUND@GET_CLOUD_DOCUMENTS_SUCCESS";
export const GET_CLOUD_DOCUMENTS_FAILED = "FUND@GET_CLOUD_DOCUMENTS_FAILED";

export const UPLOAD_FILE_DECK = "UPLOAD_FILE_DECK";
export const UPLOAD_FILE_DECK_INIT = "UPLOAD_FILE_DECK_INIT";
export const UPLOAD_FILE_DECK_SUCCESS = "UPLOAD_FILE_DECK_SUCCESS";
export const UPLOAD_FILE_DECK_FAILED = "UPLOAD_FILE_DECK_FAILED";
